import { zip, AsyncZippable } from 'fflate'

/**
 * Zips all files client-side using STORE mode (level 0 = no compression).
 * Binary tachograph files (.ddd, .dtg etc.) don't compress meaningfully.
 * This eliminates N HTTP round trips (one per batch) down to a single upload.
 */
export function zipFiles(files: File[]): Promise<Uint8Array> {
  return new Promise((resolve, reject) => {
    Promise.all(
      files.map(async (file) => {
        const buffer = await file.arrayBuffer()
        return [file.name, new Uint8Array(buffer)] as const
      })
    ).then((entries) => {
      const zippable: AsyncZippable = {}
      for (const [name, data] of entries) {
        zippable[name] = [data, { level: 0 }]
      }
      zip(zippable, (err, result) => {
        if (err) reject(err)
        else resolve(result)
      })
    }).catch(reject)
  })
}
